
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.214 7.393a5.432 5.432 0 01-.54-1.088C14.673 2.358 11.026 0 7.5 0A7.444 7.444 0 000 7.547c0 2.7 1.01 4.707 3 5.968v4.11a.375.375 0 00.375.375h7.5a.375.375 0 00.375-.375v-2.233c1.304-.013 2.1-.156 2.68-.736.626-.627.716-2.504.72-3.395.226 0 .514.004.763-.006a.93.93 0 00.722-.39.916.916 0 00.143-.557v-.103c.063-.837-.536-1.887-1.065-2.812zm-7.446 5.732a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm1.2-4.56a.75.75 0 00-.45.688.75.75 0 01-1.5 0 2.25 2.25 0 011.35-2.063 1.5 1.5 0 10-2.1-1.374.75.75 0 01-1.5 0 3 3 0 114.2 2.75z","fill":"currentColor"}})])
          )
        }
      }
    